// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import {
//   FaBox,
//   FaCheckCircle,
//   FaClock,
//   FaTruck,
//   FaTimesCircle,
//   FaEye,
//   FaSearch,
//   FaChevronLeft,
//   FaChevronRight,
//   FaSpinner,
//   FaClipboardList,
//   FaUser,
//   FaPhone,
//   FaShoppingBag,
//   FaCheck,
//   FaPalette,
// } from 'react-icons/fa';
// import './orders.scss';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import withAuth from '../../../auth/WithAuth';
// import { serverUrlAuth } from '../../../../serverUrl';
// import { toast } from 'react-toastify';

// const ArtisanOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [showOrderModal, setShowOrderModal] = useState(false);
//   const [showStatusModal, setShowStatusModal] = useState(false);
//   const [statusLoading, setStatusLoading] = useState(false);
//   const [updatingOrderId, setUpdatingOrderId] = useState(null);

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);

//   // Status config
//   const STATUS_CONFIG = {
//     new: { label: 'New', color: '#17a2b8', icon: FaClock, bg: '#e3f2fd' },
//     accepted: { label: 'Accepted', color: '#28a745', icon: FaCheckCircle, bg: '#d4edda' },
//     processing: { label: 'Processing', color: '#ffc107', icon: FaSpinner, bg: '#fff3cd' },
//     ready: { label: 'Ready', color: '#17a2b8', icon: FaBox, bg: '#d1ecf1' },
//     shipped: { label: 'Shipped', color: '#6f42c1', icon: FaTruck, bg: '#e8d9f5' },
//     delivered: { label: 'Delivered', color: '#28a745', icon: FaCheckCircle, bg: '#d4edda' },
//     cancelled: { label: 'Cancelled', color: '#dc3545', icon: FaTimesCircle, bg: '#f8d7da' },
//   };

//   const STATUS_OPTIONS = [
//     { value: 'new', label: 'New' },
//     { value: 'accepted', label: 'Accepted' },
//     { value: 'processing', label: 'Processing' },
//     { value: 'ready', label: 'Ready' },
//     { value: 'shipped', label: 'Shipped' },
//     { value: 'delivered', label: 'Delivered' },
//     { value: 'cancelled', label: 'Cancelled' },
//   ];

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   const fetchOrders = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get('artisan-ready-made-orders/');
//       console.log('Orders response:', response.data);
//       setOrders(response.data.orders || []);
//     } catch (error) {
//       console.error('Error fetching orders:', error);
//       toast.error('Failed to load orders');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateOrderStatus = async (orderId, newStatus) => {
//     try {
//       setStatusLoading(true);
//       setUpdatingOrderId(orderId);

//       const response = await serverUrlAuth.patch(
//         `artisan-ready-made-orders/${orderId}/status/`,
//         { status: newStatus },
//       );

//       console.log('Status update response:', response.data);

//       setOrders(
//         orders.map((order) =>
//           order.id === orderId ? response.data.order : order,
//         ),
//       );

//       toast.success('Order status updated successfully');
//       setShowStatusModal(false);

//       if (selectedOrder && selectedOrder.id === orderId) {
//         setSelectedOrder(response.data.order);
//       }
//     } catch (error) {
//       console.error('Error updating status:', error);
//       toast.error(error.response?.data?.error || 'Failed to update status');
//     } finally {
//       setStatusLoading(false);
//       setUpdatingOrderId(null);
//     }
//   };

//   const handleViewOrder = (order) => {
//     setSelectedOrder(order);
//     setShowOrderModal(true);
//   };

//   const handleOpenStatusModal = (order) => {
//     setSelectedOrder(order);
//     setShowStatusModal(true);
//   };

//   const getStatusConfig = (status) => {
//     return STATUS_CONFIG[status] || STATUS_CONFIG.new;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const formatCurrency = (amount) => {
//     if (!amount || amount === 0) return 'KSh 0';
//     return `KSh ${parseFloat(amount).toLocaleString()}`;
//   };

//   // Get first item from order for display
//   const getFirstItem = (order) => {
//     if (!order.items || order.items.length === 0) return null;
//     return order.items[0];
//   };

//   // Get all product names from order items
//   const getProductNames = (order) => {
//     if (!order.items || order.items.length === 0) return 'N/A';
//     return order.items.map(item => item.product_name).join(', ');
//   };

//   // Get total items count
//   const getTotalItems = (order) => {
//     if (!order.items) return 0;
//     return order.items.reduce((sum, item) => sum + item.quantity, 0);
//   };

//   // Filter orders
//   const filteredOrders = orders.filter((order) => {
//     const matchesSearch =
//       order.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       order.id?.toString().includes(searchTerm) ||
//       order.customer_order_reference?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       getProductNames(order)?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesStatus =
//       filterStatus === 'all' || order.status === filterStatus;

//     return matchesSearch && matchesStatus;
//   });

//   // Pagination
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentOrders = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

//   const paginate = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // Get status counts
//   const getStatusCounts = () => {
//     const counts = {};
//     orders.forEach((order) => {
//       counts[order.status] = (counts[order.status] || 0) + 1;
//     });
//     return counts;
//   };

//   const statusCounts = getStatusCounts();

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="artisan-orders-page">
//           <div className="loading-container">
//             <FaSpinner className="spinner" />
//             <p>Loading orders...</p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="artisan-orders-page">
//         <div className="orders-container">
//           {/* Header */}
//           <div className="orders-header">
//             <div className="header-left">
//               <h1>Ready-Made Orders</h1>
//               <p className="orders-count">
//                 {orders.length} {orders.length === 1 ? 'order' : 'orders'} total
//               </p>
//             </div>
//           </div>

//           {/* Status Summary Cards */}
//           <div className="status-summary">
//             <div
//               className={`status-card ${filterStatus === 'all' ? 'active' : ''}`}
//               onClick={() => setFilterStatus('all')}
//             >
//               <div className="status-icon">📦</div>
//               <div className="status-info">
//                 <div className="status-count">{orders.length}</div>
//                 <div className="status-label">All Orders</div>
//               </div>
//             </div>
//             {Object.keys(STATUS_CONFIG).map((status) => {
//               const config = getStatusConfig(status);
//               const count = statusCounts[status] || 0;
//               if (count === 0) return null;
//               const IconComponent = config.icon;
//               return (
//                 <div
//                   key={status}
//                   className={`status-card ${filterStatus === status ? 'active' : ''}`}
//                   onClick={() => setFilterStatus(status)}
//                   style={{
//                     borderColor:
//                       filterStatus === status ? config.color : 'transparent',
//                   }}
//                 >
//                   <div className="status-icon" style={{ color: config.color }}>
//                     <IconComponent />
//                   </div>
//                   <div className="status-info">
//                     <div className="status-count">{count}</div>
//                     <div className="status-label">{config.label}</div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Filters */}
//           <div className="filters-bar">
//             <div className="search-box">
//               <FaSearch />
//               <input
//                 type="text"
//                 placeholder="Search by order ID, customer, product..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//               {searchTerm && (
//                 <button
//                   className="clear-search"
//                   onClick={() => setSearchTerm('')}
//                 >
//                   ×
//                 </button>
//               )}
//             </div>
//             <div className="filter-actions">
//               <select
//                 className="filter-select"
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//               >
//                 <option value="all">All Status</option>
//                 {STATUS_OPTIONS.map((option) => (
//                   <option key={option.value} value={option.value}>
//                     {option.label}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Orders Table */}
//           {currentOrders.length === 0 ? (
//             <div className="empty-state">
//               <div className="empty-icon">
//                 <FaClipboardList />
//               </div>
//               <h2>No orders found</h2>
//               <p>
//                 {searchTerm || filterStatus !== 'all'
//                   ? 'Try adjusting your search or filter criteria'
//                   : 'You have no ready-made orders yet'}
//               </p>
//               {(searchTerm || filterStatus !== 'all') && (
//                 <button
//                   className="clear-filters-btn"
//                   onClick={() => {
//                     setSearchTerm('');
//                     setFilterStatus('all');
//                   }}
//                 >
//                   Clear Filters
//                 </button>
//               )}
//             </div>
//           ) : (
//             <>
//               <div className="orders-table-wrapper">
//                 <table className="orders-table">
//                   <thead>
//                     <tr>
//                       <th>Order ID</th>
//                       <th>Customer</th>
//                       <th>Products</th>
//                       <th>Colors</th>
//                       <th>Qty</th>
//                       <th>Total</th>
//                       <th>Status</th>
//                       <th>Date</th>
//                       <th>Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentOrders.map((order) => {
//                       const statusConfig = getStatusConfig(order.status);
//                       const StatusIcon = statusConfig.icon;
//                       const firstItem = getFirstItem(order);
//                       const totalItems = getTotalItems(order);
//                       const productNames = getProductNames(order);

//                       return (
//                         <tr key={order.id}>
//                           <td>
//                             <div className="order-id">
//                               #{order.id}
//                               <span className="order-ref">
//                                 {order.customer_order_reference}
//                               </span>
//                             </div>
//                           </td>
//                           <td>
//                             <div className="customer-info">
//                               <div className="customer-name">
//                                 {order.customer_name}
//                               </div>
//                               <div className="customer-phone">
//                                 <FaPhone /> {order.customer_phone || 'N/A'}
//                               </div>
//                             </div>
//                           </td>
//                           <td>
//                             <div className="product-info-cell">
//                               {firstItem && firstItem.product_image && (
//                                 <img
//                                   src={firstItem.product_image}
//                                   alt={firstItem.product_name}
//                                   className="product-thumb-small"
//                                 />
//                               )}
//                               <div className="product-names">
//                                 <span className="product-name-main">
//                                   {firstItem?.product_name || 'N/A'}
//                                 </span>
//                                 {order.items && order.items.length > 1 && (
//                                   <span className="product-more">
//                                     +{order.items.length - 1} more
//                                   </span>
//                                 )}
//                               </div>
//                             </div>
//                           </td>
//                           <td>
//                             <div className="color-info-cell">
//                               {order.items && order.items.map((item, index) => (
//                                 <div key={index} className="color-item">
//                                   <span
//                                     className="color-dot-small"
//                                     style={{
//                                       backgroundColor: item.color_code || '#ccc',
//                                     }}
//                                   />
//                                   <span className="color-name-small">
//                                     {item.color_name || 'N/A'}
//                                   </span>
//                                   {index < order.items.length - 1 && ', '}
//                                 </div>
//                               ))}
//                             </div>
//                           </td>
//                           <td>
//                             <div className="items-count">
//                               <FaShoppingBag />
//                               {totalItems}
//                             </div>
//                           </td>
//                           <td className="order-total">
//                             {formatCurrency(order.subtotal)}
//                           </td>
//                           <td>
//                             <span
//                               className="status-badge"
//                               style={{
//                                 background: statusConfig.bg,
//                                 color: statusConfig.color,
//                               }}
//                             >
//                               <StatusIcon />
//                               {statusConfig.label}
//                             </span>
//                           </td>
//                           <td>
//                             <div className="order-date">
//                               {formatDate(order.created_at)}
//                             </div>
//                           </td>
//                           <td>
//                             <div className="action-buttons">
//                               <button
//                                 className="view-btn"
//                                 onClick={() => handleViewOrder(order)}
//                                 title="View details"
//                               >
//                                 <FaEye />
//                               </button>
//                               {order.status !== 'delivered' &&
//                                 order.status !== 'cancelled' && (
//                                   <button
//                                     className="status-btn"
//                                     onClick={() => handleOpenStatusModal(order)}
//                                     title="Update status"
//                                   >
//                                     <FaCheck />
//                                   </button>
//                                 )}
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <div className="pagination">
//                   <button
//                     className="pagination-btn"
//                     onClick={() => paginate(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   >
//                     <FaChevronLeft />
//                   </button>
//                   <span className="page-info">
//                     Page {currentPage} of {totalPages}
//                   </span>
//                   <button
//                     className="pagination-btn"
//                     onClick={() => paginate(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   >
//                     <FaChevronRight />
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         {/* ============================================= */}
//         {/* ORDER DETAIL MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showOrderModal}
//           onHide={() => setShowOrderModal(false)}
//           size="lg"
//           centered
//           className="order-detail-modal"
//         >
//           {selectedOrder && (
//             <>
//               <Modal.Header closeButton>
//                 <h2>Order #{selectedOrder.id}</h2>
//               </Modal.Header>
//               <Modal.Body>
//                 <div className="order-detail-content">
//                   {/* Order Summary */}
//                   <div className="order-summary-header">
//                     <div className="order-meta">
//                       <div className="meta-item">
//                         <span className="meta-label">Reference:</span>
//                         <span className="meta-value">
//                           {selectedOrder.customer_order_reference}
//                         </span>
//                       </div>
//                       <div className="meta-item">
//                         <span className="meta-label">Date:</span>
//                         <span className="meta-value">
//                           {formatDate(selectedOrder.created_at)}
//                         </span>
//                       </div>
//                       <div className="meta-item">
//                         <span className="meta-label">Status:</span>
//                         {(() => {
//                           const config = getStatusConfig(selectedOrder.status);
//                           const Icon = config.icon;
//                           return (
//                             <span
//                               className="status-badge-large"
//                               style={{
//                                 background: config.bg,
//                                 color: config.color,
//                               }}
//                             >
//                               <Icon />
//                               {config.label}
//                             </span>
//                           );
//                         })()}
//                       </div>
//                       <div className="meta-item">
//                         <span className="meta-label">Total:</span>
//                         <span className="meta-value total">
//                           {formatCurrency(selectedOrder.subtotal)}
//                         </span>
//                       </div>
//                       <div className="meta-item">
//                         <span className="meta-label">Payment:</span>
//                         <span className="meta-value">
//                           {selectedOrder.payment_status || 'N/A'}
//                         </span>
//                       </div>
//                     </div>

//                     {/* Customer Info */}
//                     <div className="customer-details">
//                       <h4>
//                         <FaUser /> Customer
//                       </h4>
//                       <div className="customer-info-detail">
//                         <p>
//                           <strong>Name:</strong> {selectedOrder.customer_name}
//                         </p>
//                         <p>
//                           <strong>Phone:</strong>{' '}
//                           {selectedOrder.customer_phone || 'N/A'}
//                         </p>
//                         <p>
//                           <strong>Shipping Address:</strong>
//                         </p>
//                         <p className="shipping-address">
//                           {selectedOrder.shipping_address}
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Order Items */}
//                   <div className="order-items-section">
//                     <h4>
//                       <FaShoppingBag /> Items
//                     </h4>
//                     <div className="items-table-wrapper">
//                       <table className="items-table">
//                         <thead>
//                           <tr>
//                             <th>Product</th>
//                             <th>Color</th>
//                             <th>Qty</th>
//                             <th>Unit Price</th>
//                             <th>Total</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {selectedOrder.items?.map((item) => (
//                             <tr key={item.id}>
//                               <td>
//                                 <div className="product-info">
//                                   {item.product_image && (
//                                     <img
//                                       src={item.product_image}
//                                       alt={item.product_name}
//                                       className="product-thumb"
//                                     />
//                                   )}
//                                   <span className="product-name">
//                                     {item.product_name}
//                                   </span>
//                                   <span className="product-code">
//                                     {item.product_code}
//                                   </span>
//                                 </div>
//                               </td>
//                               <td>
//                                 {item.color_name && (
//                                   <div className="color-info">
//                                     <span
//                                       className="color-dot"
//                                       style={{
//                                         backgroundColor:
//                                           item.color_code || '#ccc',
//                                       }}
//                                     />
//                                     <span>{item.color_name}</span>
//                                   </div>
//                                 )}
//                               </td>
//                               <td>{item.quantity}</td>
//                               <td>{formatCurrency(item.unit_price)}</td>
//                               <td className="item-total">
//                                 {formatCurrency(item.total_price)}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>

//                   {/* Status Timeline */}
//                   <div className="status-timeline">
//                     <h4>Order Timeline</h4>
//                     <div className="timeline">
//                       {selectedOrder.created_at && (
//                         <div className="timeline-item">
//                           <div className="timeline-dot complete"></div>
//                           <div className="timeline-content">
//                             <div className="timeline-title">Order Placed</div>
//                             <div className="timeline-date">
//                               {formatDate(selectedOrder.created_at)}
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {selectedOrder.accepted_at && (
//                         <div className="timeline-item">
//                           <div className="timeline-dot complete"></div>
//                           <div className="timeline-content">
//                             <div className="timeline-title">Accepted</div>
//                             <div className="timeline-date">
//                               {formatDate(selectedOrder.accepted_at)}
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {selectedOrder.processing_at && (
//                         <div className="timeline-item">
//                           <div className="timeline-dot complete"></div>
//                           <div className="timeline-content">
//                             <div className="timeline-title">Processing</div>
//                             <div className="timeline-date">
//                               {formatDate(selectedOrder.processing_at)}
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {selectedOrder.ready_at && (
//                         <div className="timeline-item">
//                           <div className="timeline-dot complete"></div>
//                           <div className="timeline-content">
//                             <div className="timeline-title">Ready</div>
//                             <div className="timeline-date">
//                               {formatDate(selectedOrder.ready_at)}
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {selectedOrder.shipped_at && (
//                         <div className="timeline-item">
//                           <div className="timeline-dot complete"></div>
//                           <div className="timeline-content">
//                             <div className="timeline-title">Shipped</div>
//                             <div className="timeline-date">
//                               {formatDate(selectedOrder.shipped_at)}
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {selectedOrder.delivered_at && (
//                         <div className="timeline-item">
//                           <div className="timeline-dot complete"></div>
//                           <div className="timeline-content">
//                             <div className="timeline-title">Delivered</div>
//                             <div className="timeline-date">
//                               {formatDate(selectedOrder.delivered_at)}
//                             </div>
//                           </div>
//                         </div>
//                       )}
//                       {selectedOrder.cancelled_at && (
//                         <div className="timeline-item cancelled">
//                           <div className="timeline-dot cancelled"></div>
//                           <div className="timeline-content">
//                             <div className="timeline-title">Cancelled</div>
//                             <div className="timeline-date">
//                               {formatDate(selectedOrder.cancelled_at)}
//                             </div>
//                             {selectedOrder.cancellation_reason && (
//                               <div className="cancellation-reason">
//                                 Reason: {selectedOrder.cancellation_reason}
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </Modal.Body>
//               <Modal.Footer>
//                 {selectedOrder.status !== 'delivered' &&
//                   selectedOrder.status !== 'cancelled' && (
//                     <button
//                       className="btn btn-primary"
//                       onClick={() => {
//                         setShowOrderModal(false);
//                         handleOpenStatusModal(selectedOrder);
//                       }}
//                     >
//                       <FaCheck /> Update Status
//                     </button>
//                   )}
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => setShowOrderModal(false)}
//                 >
//                   Close
//                 </button>
//               </Modal.Footer>
//             </>
//           )}
//         </Modal>

//         {/* ============================================= */}
//         {/* STATUS UPDATE MODAL */}
//         {/* ============================================= */}
//         <Modal
//           show={showStatusModal}
//           onHide={() => setShowStatusModal(false)}
//           centered
//           className="status-modal"
//         >
//           {selectedOrder && (
//             <>
//               <Modal.Header closeButton>
//                 <h2>Update Order Status</h2>
//               </Modal.Header>
//               <Modal.Body>
//                 <div className="status-update-content">
//                   <div className="current-status">
//                     <span>Current Status:</span>
//                     {(() => {
//                       const config = getStatusConfig(selectedOrder.status);
//                       const Icon = config.icon;
//                       return (
//                         <span
//                           className="status-badge-large"
//                           style={{
//                             background: config.bg,
//                             color: config.color,
//                           }}
//                         >
//                           <Icon />
//                           {config.label}
//                         </span>
//                       );
//                     })()}
//                   </div>

//                   <div className="status-options">
//                     <label>Select New Status:</label>
//                     <div className="status-option-grid">
//                       {STATUS_OPTIONS.map((option) => {
//                         const config = getStatusConfig(option.value);
//                         const Icon = config.icon;
//                         const isDisabled =
//                           option.value === selectedOrder.status;

//                         return (
//                           <button
//                             key={option.value}
//                             className={`status-option-btn ${selectedOrder.status === option.value ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
//                             onClick={() => {
//                               if (!isDisabled) {
//                                 updateOrderStatus(
//                                   selectedOrder.id,
//                                   option.value,
//                                 );
//                               }
//                             }}
//                             disabled={isDisabled || statusLoading}
//                             style={{
//                               borderColor: isDisabled
//                                 ? '#e0e0e0'
//                                 : config.color,
//                             }}
//                           >
//                             <Icon
//                               style={{
//                                 color: isDisabled ? '#ccc' : config.color,
//                               }}
//                             />
//                             <span>{option.label}</span>
//                             {selectedOrder.status === option.value && (
//                               <FaCheck className="check-icon" />
//                             )}
//                           </button>
//                         );
//                       })}
//                     </div>
//                   </div>

//                   {selectedOrder.status === 'cancelled' && (
//                     <div className="cancellation-note">
//                       <p>This order has been cancelled.</p>
//                       {selectedOrder.cancellation_reason && (
//                         <p>
//                           <strong>Reason:</strong>{' '}
//                           {selectedOrder.cancellation_reason}
//                         </p>
//                       )}
//                     </div>
//                   )}

//                   {statusLoading && (
//                     <div className="status-loading">
//                       <FaSpinner className="spinner" />
//                       <span>Updating status...</span>
//                     </div>
//                   )}
//                 </div>
//               </Modal.Body>
//               <Modal.Footer>
//                 <button
//                   className="btn btn-secondary"
//                   onClick={() => setShowStatusModal(false)}
//                   disabled={statusLoading}
//                 >
//                   Cancel
//                 </button>
//               </Modal.Footer>
//             </>
//           )}
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(ArtisanOrders, 'artisan');



// src/pages/artisan/orders/ArtisanOrders.jsx
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import {
  FaBox,
  FaCheckCircle,
  FaClock,
  FaTruck,
  FaTimesCircle,
  FaEye,
  FaSearch,
  FaChevronLeft,
  FaChevronRight,
  FaSpinner,
  FaClipboardList,
  FaUser,
  FaPhone,
  FaShoppingBag,
  FaCheck,
  FaPalette,
} from 'react-icons/fa';
import './orders.scss';
import Sidebar from '../../../../components/layout/Sidebar';
import withAuth from '../../../auth/WithAuth';
import { serverUrlAuth } from '../../../../serverUrl';
import { toast } from 'react-toastify';

const ArtisanOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [updatingOrderId, setUpdatingOrderId] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Status config
  const STATUS_CONFIG = {
    new: { label: 'New', color: '#17a2b8', icon: FaClock, bg: '#e3f2fd' },
    accepted: { label: 'Accepted', color: '#28a745', icon: FaCheckCircle, bg: '#d4edda' },
    processing: { label: 'Processing', color: '#ffc107', icon: FaSpinner, bg: '#fff3cd' },
    ready: { label: 'Ready', color: '#17a2b8', icon: FaBox, bg: '#d1ecf1' },
    shipped: { label: 'Shipped', color: '#6f42c1', icon: FaTruck, bg: '#e8d9f5' },
    delivered: { label: 'Delivered', color: '#28a745', icon: FaCheckCircle, bg: '#d4edda' },
    cancelled: { label: 'Cancelled', color: '#dc3545', icon: FaTimesCircle, bg: '#f8d7da' },
  };

  const STATUS_OPTIONS = [
    { value: 'new', label: 'New' },
    { value: 'accepted', label: 'Accepted' },
    { value: 'processing', label: 'Processing' },
    { value: 'ready', label: 'Ready' },
    { value: 'shipped', label: 'Shipped' },
    { value: 'delivered', label: 'Delivered' },
    { value: 'cancelled', label: 'Cancelled' },
  ];

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get('artisan-ready-made-orders/');
      console.log('Orders response:', response.data);
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error('Error fetching orders:', error);
      toast.error('Failed to load orders');
    } finally {
      setLoading(false);
    }
  };

  const updateOrderStatus = async (orderId, newStatus) => {
    try {
      setStatusLoading(true);
      setUpdatingOrderId(orderId);

      const response = await serverUrlAuth.patch(
        `artisan-ready-made-orders/${orderId}/status/`,
        { status: newStatus },
      );

      console.log('Status update response:', response.data);

      setOrders(
        orders.map((order) =>
          order.id === orderId ? response.data.order : order,
        ),
      );

      toast.success('Order status updated successfully');
      setShowStatusModal(false);

      if (selectedOrder && selectedOrder.id === orderId) {
        setSelectedOrder(response.data.order);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error(error.response?.data?.error || 'Failed to update status');
    } finally {
      setStatusLoading(false);
      setUpdatingOrderId(null);
    }
  };

  const handleViewOrder = (order) => {
    setSelectedOrder(order);
    setShowOrderModal(true);
  };

  const handleOpenStatusModal = (order) => {
    setSelectedOrder(order);
    setShowStatusModal(true);
  };

  const getStatusConfig = (status) => {
    return STATUS_CONFIG[status] || STATUS_CONFIG.new;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return 'KSh 0';
    return `KSh ${parseFloat(amount).toLocaleString()}`;
  };

  // Get first item from order for display
  const getFirstItem = (order) => {
    if (!order.items || order.items.length === 0) return null;
    return order.items[0];
  };

  // Get all product names from order items
  const getProductNames = (order) => {
    if (!order.items || order.items.length === 0) return 'N/A';
    return order.items.map((item) => item.product_name).join(', ');
  };

  // Get total items count
  const getTotalItems = (order) => {
    if (!order.items) return 0;
    return order.items.reduce((sum, item) => sum + item.quantity, 0);
  };

  // Filter orders
  const filteredOrders = orders.filter((order) => {
    const matchesSearch =
      order.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.id?.toString().includes(searchTerm) ||
      order.customer_order_reference
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      getProductNames(order)?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      filterStatus === 'all' || order.status === filterStatus;

    return matchesSearch && matchesStatus;
  });

  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentOrders = filteredOrders.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Get status counts
  const getStatusCounts = () => {
    const counts = {};
    orders.forEach((order) => {
      counts[order.status] = (counts[order.status] || 0) + 1;
    });
    return counts;
  };

  const statusCounts = getStatusCounts();

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="modern-dashboard artisan-orders-page">
          <div className="loading-container">
            <FaSpinner className="spinner" />
            <p>Loading orders...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard artisan-orders-page">
        <div className="orders-container">
        

          {/* Header */}
          <div className="orders-header">
            <div className="header-left">
              <h1>Ready-Made Orders</h1>
              <p className="orders-count">
                {orders.length} {orders.length === 1 ? 'order' : 'orders'} total
              </p>
            </div>
          </div>

          {/* Status Summary Cards */}
          <div className="status-summary">
            <div
              className={`status-card ${
                filterStatus === 'all' ? 'active' : ''
              }`}
              onClick={() => setFilterStatus('all')}
            >
              <div className="status-icon">📦</div>
              <div className="status-info">
                <div className="status-count">{orders.length}</div>
                <div className="status-label">All Orders</div>
              </div>
            </div>
            {Object.keys(STATUS_CONFIG).map((status) => {
              const config = getStatusConfig(status);
              const count = statusCounts[status] || 0;
              if (count === 0) return null;
              const IconComponent = config.icon;
              return (
                <div
                  key={status}
                  className={`status-card ${
                    filterStatus === status ? 'active' : ''
                  }`}
                  onClick={() => setFilterStatus(status)}
                  style={{
                    borderColor:
                      filterStatus === status ? config.color : 'transparent',
                  }}
                >
                  <div className="status-icon" style={{ color: config.color }}>
                    <IconComponent />
                  </div>
                  <div className="status-info">
                    <div className="status-count">{count}</div>
                    <div className="status-label">{config.label}</div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Filters */}
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch />
              <input
                type="text"
                placeholder="Search by order ID, customer, product..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  className="clear-search"
                  onClick={() => setSearchTerm('')}
                >
                  ×
                </button>
              )}
            </div>
            <div className="filter-actions">
              <select
                className="filter-select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All Status</option>
                {STATUS_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Orders Table */}
          {currentOrders.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">
                <FaClipboardList />
              </div>
              <h2>No orders found</h2>
              <p>
                {searchTerm || filterStatus !== 'all'
                  ? 'Try adjusting your search or filter criteria'
                  : 'You have no ready-made orders yet'}
              </p>
              {(searchTerm || filterStatus !== 'all') && (
                <button
                  className="clear-filters-btn"
                  onClick={() => {
                    setSearchTerm('');
                    setFilterStatus('all');
                  }}
                >
                  Clear Filters
                </button>
              )}
            </div>
          ) : (
            <>
              <div className="orders-table-wrapper">
                <table className="orders-table">
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Customer</th>
                      <th>Products</th>
                      <th>Colors</th>
                      <th>Qty</th>
                      <th>Total</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentOrders.map((order) => {
                      const statusConfig = getStatusConfig(order.status);
                      const StatusIcon = statusConfig.icon;
                      const firstItem = getFirstItem(order);
                      const totalItems = getTotalItems(order);
                      const productNames = getProductNames(order);

                      return (
                        <tr key={order.id}>
                          <td>
                            <div className="order-id">
                              #{order.id}
                              <span className="order-ref">
                                {order.customer_order_reference}
                              </span>
                            </div>
                          </td>
                          <td>
                            <div className="customer-info">
                              <div className="customer-name">
                                {order.customer_name}
                              </div>
                              <div className="customer-phone">
                                <FaPhone /> {order.customer_phone || 'N/A'}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="product-info-cell">
                              {firstItem && firstItem.product_image && (
                                <img
                                  src={firstItem.product_image}
                                  alt={firstItem.product_name}
                                  className="product-thumb-small"
                                />
                              )}
                              <div className="product-names">
                                <span className="product-name-main">
                                  {firstItem?.product_name || 'N/A'}
                                </span>
                                {order.items && order.items.length > 1 && (
                                  <span className="product-more">
                                    +{order.items.length - 1} more
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="color-info-cell">
                              {order.items &&
                                order.items.map((item, index) => (
                                  <div key={index} className="color-item">
                                    <span
                                      className="color-dot-small"
                                      style={{
                                        backgroundColor:
                                          item.color_code || '#ccc',
                                      }}
                                    />
                                    <span className="color-name-small">
                                      {item.color_name || 'N/A'}
                                    </span>
                                    {index < order.items.length - 1 && ', '}
                                  </div>
                                ))}
                            </div>
                          </td>
                          <td>
                            <div className="items-count">
                              <FaShoppingBag />
                              {totalItems}
                            </div>
                          </td>
                          <td className="order-total">
                            {formatCurrency(order.subtotal)}
                          </td>
                          <td>
                            <span
                              className="status-badge"
                              style={{
                                background: statusConfig.bg,
                                color: statusConfig.color,
                              }}
                            >
                              <StatusIcon />
                              {statusConfig.label}
                            </span>
                          </td>
                          <td>
                            <div className="order-date">
                              {formatDate(order.created_at)}
                            </div>
                          </td>
                          <td>
                            <div className="action-buttons">
                              <button
                                className="view-btn"
                                onClick={() => handleViewOrder(order)}
                                title="View details"
                              >
                                <FaEye />
                              </button>
                              {order.status !== 'delivered' &&
                                order.status !== 'cancelled' && (
                                  <button
                                    className="status-btn"
                                    onClick={() =>
                                      handleOpenStatusModal(order)
                                    }
                                    title="Update status"
                                  >
                                    <FaCheck />
                                  </button>
                                )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination">
                  <button
                    className="pagination-btn"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <FaChevronLeft />
                  </button>
                  <span className="page-info">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="pagination-btn"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <FaChevronRight />
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {/* ============================================= */}
        {/* ORDER DETAIL MODAL */}
        {/* ============================================= */}
        <Modal
          show={showOrderModal}
          onHide={() => setShowOrderModal(false)}
          size="lg"
          centered
          className="order-detail-modal"
        >
          {selectedOrder && (
            <>
              <Modal.Header closeButton>
                <h2>Order #{selectedOrder.id}</h2>
              </Modal.Header>
              <Modal.Body>
                <div className="order-detail-content">
                  {/* Order Summary */}
                  <div className="order-summary-header">
                    <div className="order-meta">
                      <div className="meta-item">
                        <span className="meta-label">Reference:</span>
                        <span className="meta-value">
                          {selectedOrder.customer_order_reference}
                        </span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Date:</span>
                        <span className="meta-value">
                          {formatDate(selectedOrder.created_at)}
                        </span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Status:</span>
                        {(() => {
                          const config = getStatusConfig(
                            selectedOrder.status,
                          );
                          const Icon = config.icon;
                          return (
                            <span
                              className="status-badge-large"
                              style={{
                                background: config.bg,
                                color: config.color,
                              }}
                            >
                              <Icon />
                              {config.label}
                            </span>
                          );
                        })()}
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Total:</span>
                        <span className="meta-value total">
                          {formatCurrency(selectedOrder.subtotal)}
                        </span>
                      </div>
                      <div className="meta-item">
                        <span className="meta-label">Payment:</span>
                        <span className="meta-value">
                          {selectedOrder.payment_status || 'N/A'}
                        </span>
                      </div>
                    </div>

                    {/* Customer Info */}
                    <div className="customer-details">
                      <h4>
                        <FaUser /> Customer
                      </h4>
                      <div className="customer-info-detail">
                        <p>
                          <strong>Name:</strong> {selectedOrder.customer_name}
                        </p>
                        <p>
                          <strong>Phone:</strong>{' '}
                          {selectedOrder.customer_phone || 'N/A'}
                        </p>
                        <p>
                          <strong>Shipping Address:</strong>
                        </p>
                        <p className="shipping-address">
                          {selectedOrder.shipping_address}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Order Items */}
                  <div className="order-items-section">
                    <h4>
                      <FaShoppingBag /> Items
                    </h4>
                    <div className="items-table-wrapper">
                      <table className="items-table">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Color</th>
                            <th>Qty</th>
                            <th>Unit Price</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedOrder.items?.map((item) => (
                            <tr key={item.id}>
                              <td>
                                <div className="product-info">
                                  {item.product_image && (
                                    <img
                                      src={item.product_image}
                                      alt={item.product_name}
                                      className="product-thumb"
                                    />
                                  )}
                                  <span className="product-name">
                                    {item.product_name}
                                  </span>
                                  <span className="product-code">
                                    {item.product_code}
                                  </span>
                                </div>
                              </td>
                              <td>
                                {item.color_name && (
                                  <div className="color-info">
                                    <span
                                      className="color-dot"
                                      style={{
                                        backgroundColor:
                                          item.color_code || '#ccc',
                                      }}
                                    />
                                    <span>{item.color_name}</span>
                                  </div>
                                )}
                              </td>
                              <td>{item.quantity}</td>
                              <td>{formatCurrency(item.unit_price)}</td>
                              <td className="item-total">
                                {formatCurrency(item.total_price)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Status Timeline */}
                  <div className="status-timeline">
                    <h4>Order Timeline</h4>
                    <div className="timeline">
                      {selectedOrder.created_at && (
                        <div className="timeline-item">
                          <div className="timeline-dot complete"></div>
                          <div className="timeline-content">
                            <div className="timeline-title">
                              Order Placed
                            </div>
                            <div className="timeline-date">
                              {formatDate(selectedOrder.created_at)}
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedOrder.accepted_at && (
                        <div className="timeline-item">
                          <div className="timeline-dot complete"></div>
                          <div className="timeline-content">
                            <div className="timeline-title">Accepted</div>
                            <div className="timeline-date">
                              {formatDate(selectedOrder.accepted_at)}
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedOrder.processing_at && (
                        <div className="timeline-item">
                          <div className="timeline-dot complete"></div>
                          <div className="timeline-content">
                            <div className="timeline-title">Processing</div>
                            <div className="timeline-date">
                              {formatDate(selectedOrder.processing_at)}
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedOrder.ready_at && (
                        <div className="timeline-item">
                          <div className="timeline-dot complete"></div>
                          <div className="timeline-content">
                            <div className="timeline-title">Ready</div>
                            <div className="timeline-date">
                              {formatDate(selectedOrder.ready_at)}
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedOrder.shipped_at && (
                        <div className="timeline-item">
                          <div className="timeline-dot complete"></div>
                          <div className="timeline-content">
                            <div className="timeline-title">Shipped</div>
                            <div className="timeline-date">
                              {formatDate(selectedOrder.shipped_at)}
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedOrder.delivered_at && (
                        <div className="timeline-item">
                          <div className="timeline-dot complete"></div>
                          <div className="timeline-content">
                            <div className="timeline-title">Delivered</div>
                            <div className="timeline-date">
                              {formatDate(selectedOrder.delivered_at)}
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedOrder.cancelled_at && (
                        <div className="timeline-item cancelled">
                          <div className="timeline-dot cancelled"></div>
                          <div className="timeline-content">
                            <div className="timeline-title">Cancelled</div>
                            <div className="timeline-date">
                              {formatDate(selectedOrder.cancelled_at)}
                            </div>
                            {selectedOrder.cancellation_reason && (
                              <div className="cancellation-reason">
                                Reason: {selectedOrder.cancellation_reason}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                {selectedOrder.status !== 'delivered' &&
                  selectedOrder.status !== 'cancelled' && (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setShowOrderModal(false);
                        handleOpenStatusModal(selectedOrder);
                      }}
                    >
                      <FaCheck /> Update Status
                    </button>
                  )}
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowOrderModal(false)}
                >
                  Close
                </button>
              </Modal.Footer>
            </>
          )}
        </Modal>

        {/* ============================================= */}
        {/* STATUS UPDATE MODAL */}
        {/* ============================================= */}
        <Modal
          show={showStatusModal}
          onHide={() => setShowStatusModal(false)}
          centered
          className="status-modal"
        >
          {selectedOrder && (
            <>
              <Modal.Header closeButton>
                <h2>Update Order Status</h2>
              </Modal.Header>
              <Modal.Body>
                <div className="status-update-content">
                  <div className="current-status">
                    <span>Current Status:</span>
                    {(() => {
                      const config = getStatusConfig(selectedOrder.status);
                      const Icon = config.icon;
                      return (
                        <span
                          className="status-badge-large"
                          style={{
                            background: config.bg,
                            color: config.color,
                          }}
                        >
                          <Icon />
                          {config.label}
                        </span>
                      );
                    })()}
                  </div>

                  <div className="status-options">
                    <label>Select New Status:</label>
                    <div className="status-option-grid">
                      {STATUS_OPTIONS.map((option) => {
                        const config = getStatusConfig(option.value);
                        const Icon = config.icon;
                        const isDisabled =
                          option.value === selectedOrder.status;

                        return (
                          <button
                            key={option.value}
                            className={`status-option-btn ${
                              selectedOrder.status === option.value
                                ? 'active'
                                : ''
                            } ${isDisabled ? 'disabled' : ''}`}
                            onClick={() => {
                              if (!isDisabled) {
                                updateOrderStatus(
                                  selectedOrder.id,
                                  option.value,
                                );
                              }
                            }}
                            disabled={isDisabled || statusLoading}
                            style={{
                              borderColor: isDisabled
                                ? '#e0e0e0'
                                : config.color,
                            }}
                          >
                            <Icon
                              style={{
                                color: isDisabled ? '#ccc' : config.color,
                              }}
                            />
                            <span>{option.label}</span>
                            {selectedOrder.status === option.value && (
                              <FaCheck className="check-icon" />
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {selectedOrder.status === 'cancelled' && (
                    <div className="cancellation-note">
                      <p>This order has been cancelled.</p>
                      {selectedOrder.cancellation_reason && (
                        <p>
                          <strong>Reason:</strong>{' '}
                          {selectedOrder.cancellation_reason}
                        </p>
                      )}
                    </div>
                  )}

                  {statusLoading && (
                    <div className="status-loading">
                      <FaSpinner className="spinner" />
                      <span>Updating status...</span>
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowStatusModal(false)}
                  disabled={statusLoading}
                >
                  Cancel
                </button>
              </Modal.Footer>
            </>
          )}
        </Modal>
      </div>
    </>
  );
};

export default withAuth(ArtisanOrders, 'artisan');